import React, { Children } from 'react';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import AddCircle from '@material-ui/icons/AddCircle';
import { NavLink } from 'react-router-dom';
import { Calendar, Views, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import _ from 'lodash';
import { connect } from 'react-redux';
import { resourceMap, styles } from '../shared/imports';

const mapStateToProps = (state, props) => {
	return {
		user: state.auth.user,
	};
};

const CustomMonthContainer = ({ currentUser, deleteEvent }) => props => {
	return <MonthEvent event={props} currentUser={currentUser} deleteEvent={deleteEvent} />;
};

const CustomDayContainer = ({ currentUser, deleteEvent }) => props => {
	return <Event event={props} currentUser={currentUser} deleteEvent={deleteEvent} />;
};

const Event = React.memo(props => {
	return (
		<span>
			<strong>{props.event.event.resourceTitle}</strong> />
		</span>
	);
});

const MonthEvent = React.memo(props => {
	return <span style={{ fontSize: '8pt' }}>{props.event.event.description}</span>;
	return (
		<span style={{ fontSize: '8pt', display: 'flex', justifyContent: 'space-between' }} title={props.event.event.user_note}>
			<span>{props.event.event.description}</span>
			{props.event.event.note !== '' && <span>{props.event.event.note}</span>}
		</span>
	);
});

const DragAndDropCalendar = withDragAndDrop(Calendar);
const localizer = momentLocalizer(moment);

class MyCal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			events: [],
			holidays: [],
		};
	}

	componentDidMount() {
		this.nav(
			moment()
				.startOf('month')
				.startOf('week'),
			moment()
				.endOf('month')
				.endOf('week')
		);
		this.getHolidays();
	}

	getHolidays = () => {
		axios({
			method: 'get',
			url: '/api/getHolidays',
		}).then(response => {
			if (response.data) {
				console.log('holidays found:', response);
				let holidays = [];
				_.each(response.data, t => {
					holidays.push({ date: t.date, title: t.name });
				});
				this.setState({ holidays: holidays });
			}
		});
	};

	nav = (start, end) => {
		this.setState({ dummyStart: start, dummyEnd: end });
		let url = '/api/getMySchedule';
		let that = this;
		let mongostart = start.toDate();
		let mongoend = end.toDate();
		axios({
			method: 'post',
			url: url,
			data: { start: mongostart, end: mongoend, unpublished: this.props.user.unpublished },
		}).then(function(response) {
			console.log('new monthly events:', response);
			_.each(response.data, function(v) {
				v.start = moment(v.start).toDate();
				v.end = moment(v.end).toDate();
			});
			that.setState({
				events: response.data,
			});
		});
	};

	render() {
		const items = this.state.list;
		const { classes } = this.props;
		return (
			<div>
				<h1 className={classes.h1}>
					{this.props.user.first_name} {this.props.user.last_name} Schedule
				</h1>

				<DragAndDropCalendar
					startAccessor="start"
					endAccessor="end"
					localizer={localizer}
					views={{
						month: true,
						week: false,
						day: false,
					}}
					onNavigate={(date, view) => {
						let start, end;

						if (view === 'month') {
							start = moment(date)
								.startOf('month')
								.startOf('week');
							end = moment(date)
								.endOf('month')
								.endOf('week');
							this.nav(start, end);
						}
					}}
					events={this.state.events}
					style={{ height: 800, width: '95%' }}
					defaultView={Views.MONTH}
					scrollToTime={new Date(1970, 1, 1, 6)}
					defaultDate={new Date()}
					components={{
						dateCellWrapper: ({ children, value }) => {
							return React.cloneElement(Children.only(children), {
								style: {
									...children.style,
									backgroundColor: this.state.holidays.findIndex(x => x.date === moment(value).format('YYYY-MM-DD')) >= 0 ? '#ffe8e8' : '#fff',
								},
							});
						},
						month: {
							event: CustomMonthContainer({
								currentUser: this.props.user._id,
								deleteEvent: this.deleteEvent,
							}),
							dateHeader: props => {
								console.log(props);
								let index = this.state.holidays.findIndex(x => x.date === moment(props.date).format('YYYY-MM-DD'));
								return (
									<div style={{ display: 'flex', justifyContent: 'space-between' }}>
										{index >= 0 && <span style={{ fontSize: '9pt', color: '#610c0c' }}>{this.state.holidays[index].title}</span>}
										<span>{props.label}</span>
									</div>
								);
							},
						},
						day: {
							event: CustomDayContainer({
								currentUser: this.props.user._id,
								deleteEvent: this.deleteEvent,
							}),
						},
					}}
					eventPropGetter={event => {
						//const user = this.state.listUsers.find(user => user.id === event.user_id);
						const backgroundColor = event.color;
						let marginTop = '0';
						const styles = { backgroundColor, marginTop };
						return { style: styles };
					}}
				/>
			</div>
		);
	}
}
//this can be a calendar prop
//onSelectEvent={event => alert(event.title)}
const MyCalendar = withStyles(styles, { withTheme: true })(MyCal);
export default connect(mapStateToProps)(MyCalendar);
